import React, { createContext, useContext, useState, useEffect, useCallback } from 'react'
import api from '../services/api'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  // Cuánto perfil hay respondido. Lo sirve el backend y lo consume la barra de
  // progreso del producto, que es lo que hace que un perfil diferido se acabe
  // completando en vez de quedarse a medias para siempre.
  const [profileCompleteness, setProfileCompleteness] = useState(null)

  const refreshProfile = useCallback(async () => {
    try {
      const { data } = await api.get('/profile')
      setProfileCompleteness(data?.completeness ?? null)
    } catch {
      setProfileCompleteness(null)
    }
  }, [])

  useEffect(() => {
    const token = localStorage.getItem('vf_token')
    if (token) {
      api
        .get('/auth/me')
        .then(res => {
          setUser(res.data)
          refreshProfile()
        })
        .catch(() => {
          localStorage.removeItem('vf_token')
        })
        .finally(() => setLoading(false))
    } else {
      setLoading(false)
    }
  }, [refreshProfile])

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password })
    localStorage.setItem('vf_token', res.data.token)
    setUser(res.data.user)
    return res.data
  }

  const register = async (email, password, name) => {
    const res = await api.post('/auth/register', { email, password, name })
    localStorage.setItem('vf_token', res.data.token)
    setUser(res.data.user)
    return res.data
  }

  const logout = () => {
    localStorage.removeItem('vf_token')
    setUser(null)
    setProfileCompleteness(null)
  }

  const completeOnboarding = () => {
    setUser(prev => ({ ...prev, onboarding_completed: true }))
    // El perfil acaba de nacer: la barra necesita saber cuánto falta.
    refreshProfile()
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        register,
        logout,
        completeOnboarding,
        profileCompleteness,
        refreshProfile,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
